import { CustomRoutes } from '@shared/consts/routes/custom-routes.const';
import { ClientMainPanelComponent } from '@modules/client-panel/pages/client-main-panel/client-main-panel.component';
import { TaskChangeAcceptanceComponent } from '@modules/client-panel/pages/task-change-acceptance/task-change-acceptance.component';
import { TaskChangeAcceptanceResolver } from '@modules/client-panel/pages/task-change-acceptance/task-change-acceptance.resolver';
import { EventAcceptationComponent } from '@modules/client-panel/pages/event-acceptation/event-acceptation.component';

export const ClientPanelRoutes: CustomRoutes = [
  {
    path: '',
    component: ClientMainPanelComponent,
    children: [
      {
        path: 'changes-acceptance/:token',
        name: 'changes-acceptance',
        component: TaskChangeAcceptanceComponent,
        data: {
          hideHeader: false,
          stickyFooter: true
        },
        resolve: { acceptance: TaskChangeAcceptanceResolver }
      }
    ]
  },
  {
    path: 'event/:token',
    component: EventAcceptationComponent,
    name: 'event-acceptation',
    data: {
      client: true,
      hideHeader: true
    }
  }
];
